export default __webpack_public_path__ + "static/Blind-angels-kayla-profile_mobile-770af81d02347336cab098fed97e04f0.png";